/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  let temp = content;
  if (typeof temp !== 'string') {
    temp = JSON.stringify(content);
  }
  localStorage.setItem(name, temp);
};

/**
 * 获取localStorage
 */
/* eslint-disable */
export const getStore = (name) => {
  if (!name) return;
  let content = localStorage.getItem(name);
  try {
    content = JSON.parse(content);
    return content;
  } catch (e) {
    return content;
  }
};

/**
 * 删除localStorage
 */
export const removeStore = (name) => {
  if (!name) return;
  localStorage.removeItem(name);
};
